export default from './message-root';



// WEBPACK FOOTER //
// ./app/containers/message-root/index.js